var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasSelectedWorkpackage
    ? _c("div", { staticClass: "architecture-v2-container" }, [
        _c("div", { staticClass: "filter-bar-wrapper" }, [
          _c("div", { staticClass: "filter-bar" }, [
            _c(
              "div",
              { staticClass: "filter-item" },
              [
                _c("span", { staticClass: "filter-label" }, [
                  _vm._v(_vm._s(_vm.$t("filters.pricingGroup")) + ":"),
                ]),
                _vm._v(" "),
                _c("pricing-filter", {
                  staticClass: "filter-dropdown",
                  attrs: {
                    filter: _vm.pricingGroupFilter,
                    loading: _vm.hierarchyLoading,
                    "hide-label": "",
                  },
                  on: { filterSelected: _vm.onSelectFilter },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-item" },
              [
                _c("span", { staticClass: "filter-label" }, [
                  _vm._v(_vm._s(_vm.$t("filters.scenario")) + ":"),
                ]),
                _vm._v(" "),
                _c("pricing-filter", {
                  staticClass: "filter-dropdown",
                  attrs: {
                    filter: _vm.scenarioFilter,
                    loading: _vm.scenarioLoading,
                    disabled: _vm.scenarioCalculating,
                    "hide-label": "",
                  },
                  on: { filterSelected: _vm.onSelectFilter },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-item" },
              [
                _c("span", { staticClass: "filter-label" }, [
                  _vm._v(_vm._s(_vm.$t("filters.architectureGroup")) + ":"),
                ]),
                _vm._v(" "),
                _c("pricing-filter", {
                  staticClass: "filter-dropdown",
                  attrs: {
                    filter: _vm.architectureGroupFilter,
                    loading: _vm.hierarchyLoading,
                    "hide-label": "",
                  },
                  on: { filterSelected: _vm.onSelectFilter },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tabs-section" },
          [_c("tabs", { attrs: { tabs: _vm.tabs } })],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }